import { gql, useLazyQuery } from "@apollo/client"
import { useContext, useState } from "react"
import _ from "lodash"

//PrimeReact
import { Button } from "primereact/button"

//Styles
import myStyles from "../../styles/GeminiAI.module.css"
import { classNames } from "primereact/utils"
import { LogError } from "../../helpers/logger"

//User Context
import { UserContext } from "../../context/userContext"
import { Tooltip } from "primereact/tooltip"

export default function RewriteText({
  text,
  additionalPrompt,
  tooltip,
  className,
  tooltipPosition,
  onStartRewrite,
  onCompleteRewrite,
}) {
  const userCtx = useContext(UserContext)

  const [isProcessing, setIsProcessing] = useState(false)

  const query = gql`
    query rewriteText($text: String!, $additionalPrompt: String = "") {
      geminiRewriteProfessional(
        text: $text
        additionalPrompt: $additionalPrompt
      ) {
        rewrittenText
        error
        errorStatusCode
      }
    }
  `

  const [rewriteTextQuery] = useLazyQuery(query, {
    fetchPolicy: "no-cache",
  })

  const useTooltip =
    tooltip ??
    (_.isEmpty(text)
      ? "Enter text and click here to rephrase it with Gemini AI"
      : "Click here to rephrase Text with Gemini AI")

  const handleRewrite = async () => {
    if (_.isEmpty(text)) {
      userCtx.setNotificationInformation("Please enter text to be rewritten.")
      return
    }

    setIsProcessing(true)
    onStartRewrite?.()

    try {
      const { data } = await rewriteTextQuery({
        variables: { text, additionalPrompt },
      })

      const result = data?.geminiRewriteProfessional
      const newValue = result?.rewrittenText

      if (!newValue || result?.error) {
        LogError("Error rewriting text:", result?.error)
        if (result?.errorStatusCode === 503) {
          userCtx.setNotificationError(
            "The AI model was unavailable, please try again"
          )
        } else {
          userCtx.setNotificationError(
            "Something went wrong while rewriting the text, please try again"
          )
        }

        onCompleteRewrite?.()
      } else {
        onCompleteRewrite(newValue)
      }
    } catch (error) {
      LogError("Error rewriting text:", error)
      userCtx.setNotificationError(
        "Something went wrong while rewriting the text, processing aborted"
      )
      onCompleteRewrite?.()
    } finally {
      setIsProcessing(false)
    }
  }

  if (isProcessing) {
    return (
      <>
        <Tooltip target={".tt-smartToy"} className="custom-tooltip" />
        <div
          className={classNames(
            myStyles.writingContainer,
            className,
            "tt-smartToy"
          )}
          data-pr-tooltip="Processing text..."
          data-pr-position="left"
        >
          <span className={classNames("material-icons", myStyles.robot)}>
            smart_toy
          </span>
        </div>
      </>
    )
  }

  return (
    <>
      <Button
        type="button"
        className={classNames(myStyles.aiButton, className)}
        loading={isProcessing}
        onClick={handleRewrite}
        tooltip={useTooltip}
        tooltipOptions={{
          position: tooltipPosition || "bottom",
          className: "custom-tooltip",
        }}
      >
        {!isProcessing && <span className={`material-icons `}>smart_toy</span>}
      </Button>
    </>
  )
}
